var _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPdfIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 59,
    height: 81,
    viewBox: "0 0 59 81",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M38.6673 0L58.834 20.1667L48.7506 22L38.6673 20.1667L36.834 10.0833L38.6673 0Z",
    fill: "#FAD2CF"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M38.667 20.1667V0H5.66699C2.62824 0 0.166992 2.46125 0.166992 5.5V75.1667C0.166992 78.2054 2.62824 80.6667 5.66699 80.6667H53.3337C56.3724 80.6667 58.8337 78.2054 58.8337 75.1667V20.1667H38.667Z",
    fill: "#FCE8E6"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M17.2198 62.7417V67H14.7296V54.9141H19.4444C20.352 54.9141 21.1488 55.0801 21.835 55.4121C22.5268 55.7441 23.058 56.2173 23.4288 56.8315C23.7995 57.4403 23.9849 58.1348 23.9849 58.915C23.9849 60.0993 23.5782 61.0345 22.7647 61.7207C21.9568 62.4014 20.8362 62.7417 19.4029 62.7417H17.2198ZM17.2198 60.7246H19.4444C20.1029 60.7246 20.6037 60.5697 20.9468 60.2598C21.2955 59.9499 21.4698 59.5072 21.4698 58.9316C21.4698 58.3395 21.2955 57.8608 20.9468 57.4956C20.5982 57.1304 20.1168 56.9422 19.5025 56.9312H17.2198V60.7246ZM25.7032 67V54.9141H29.4219C30.4844 54.9141 31.4335 55.1548 32.2691 55.6362C33.1103 56.1121 33.766 56.7928 34.2364 57.6782C34.7068 58.5581 34.942 59.5597 34.942 60.6831V61.2393C34.942 62.3626 34.7095 63.3615 34.2447 64.2358C33.7854 65.1102 33.1352 65.7881 32.294 66.2695C31.4529 66.751 30.5038 66.9945 29.4468 67H25.7032ZM28.1934 56.9312V64.9995H29.397C30.371 64.9995 31.1153 64.6813 31.6299 64.0449C32.1446 63.4085 32.4075 62.4982 32.4185 61.314V60.6748C32.4185 59.4463 32.164 58.5166 31.6549 57.8857C31.1457 57.2493 30.4014 56.9312 29.4219 56.9312H28.1934ZM44.0313 62.061H39.2501V67H36.7598V54.9141H44.629V56.9312H39.2501V60.0522H44.0313V62.061Z",
    fill: "#EA4335"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPdfIcon);
export default __webpack_public_path__ + "static/media/pdf-icon.6dd26c507e8f862fcb05a9aa6200015f.svg";
export { ForwardRef as ReactComponent };